export const checkbox = (checked = false) =>
  `<input type="checkbox" ${checked ? 'checked' : ''} />`
